document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('.reels-showcase-wrapper');

  wrappers.forEach(function (wrapper) {
    var grid = wrapper.querySelector('.reels-grid');
    if (!grid) return;

    var prevBtn = wrapper.querySelector('.reels-arrow-btn--left');
    var nextBtn = wrapper.querySelector('.reels-arrow-btn--right');

    // Slider drag behavior
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    function startDrag(e) {
      // Only enable custom drag for mouse, let touch use native scrolling
      if (e.type === 'touchstart') return;
      isDown = true;
      grid.classList.add('is-dragging');
      startX = e.pageX - grid.offsetLeft;
      scrollLeft = grid.scrollLeft;
    }

    function endDrag() {
      isDown = false;
      grid.classList.remove('is-dragging');
    }

    function onMove(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - grid.offsetLeft;
      var walk = (x - startX) * 1.1; // drag speed
      grid.scrollLeft = scrollLeft - walk;
    }

    grid.addEventListener('mousedown', startDrag);

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mouseleave', endDrag);

    grid.addEventListener('mousemove', onMove);

    // Arrow button scroll helpers
    function getSlideWidth() {
      var item = grid.querySelector('.reels-item');
      if (!item) return grid.clientWidth;
      var style = window.getComputedStyle(item);
      var marginRight = parseFloat(style.marginRight) || 0;
      return item.getBoundingClientRect().width + marginRight;
    }

    function updateArrowState() {
      var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
      if (!prevBtn || !nextBtn) return;

      if (grid.scrollLeft <= 2) {
        prevBtn.classList.add('reels-hidden');
      } else {
        prevBtn.classList.remove('reels-hidden');
      }

      if (grid.scrollLeft >= maxScroll) {
        nextBtn.classList.add('reels-hidden');
      } else {
        nextBtn.classList.remove('reels-hidden');
      }
    }

    function scrollByDirection(dir) {
      var amount = getSlideWidth();
      grid.scrollTo({
        left: grid.scrollLeft + dir * amount,
        behavior: 'smooth'
      });
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollByDirection(-1);
      });

      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollByDirection(1);
      });

      grid.addEventListener('scroll', updateArrowState);
      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    }

    // Mute toggle + viewport-based autoplay for uploaded videos
    var items = grid.querySelectorAll('.reels-item');
    var autoplayVideos = [];

    items.forEach(function (item) {
      var video = item.querySelector('video');
      var muteBtn = item.querySelector('.reels-mute-btn');
      if (!video) return;

      var config = { autoplay: true, muted: true, loop: true };
      var configEl = item.querySelector('.reels-video-config');
      if (configEl) {
        try {
          config = Object.assign(config, JSON.parse(configEl.textContent || '{}'));
        } catch (e) {
          // keep defaults
        }
      }

      // Safer defaults: muted so browser autoplay policies allow play when visible
      video.muted = config.muted !== false;
      video.loop = config.loop !== false;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      // Avoid fetching video bytes until near viewport
      if ('preload' in video) {
        video.preload = 'none';
      }

      if (muteBtn) {
        var iconOn = muteBtn.querySelector('.reels-mute-on');
        var iconOff = muteBtn.querySelector('.reels-mute-off');

        function updateIcons() {
          if (video.muted) {
            if (iconOn) iconOn.classList.add('reels-hidden');
            if (iconOff) iconOff.classList.remove('reels-hidden');
          } else {
            if (iconOn) iconOn.classList.remove('reels-hidden');
            if (iconOff) iconOff.classList.add('reels-hidden');
          }
        }

        updateIcons();

        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          updateIcons();
        });
      }

      if (config.autoplay !== false) {
        autoplayVideos.push(video);
      }
    });

    // Play only when reel is near the viewport; pause when far away.
    // Preserves "autoplay reels" design without loading all videos on page start.
    if (autoplayVideos.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {
                  // Autoplay can still be blocked; leave poster visible.
                });
              }
            } else {
              video.pause();
            }
          });
        },
        {
          root: null,
          // Start slightly before fully visible so scrolling feels continuous
          rootMargin: '100px 0px',
          threshold: [0, 0.35, 0.6]
        }
      );

      autoplayVideos.forEach(function (video) {
        observer.observe(video);
      });
    } else if (autoplayVideos.length) {
      // Fallback for very old browsers: only attempt first reel
      var first = autoplayVideos[0];
      if (first) {
        var playPromise = first.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    }
  });
});
